package com.wintermar.inspection.di

import com.wintermar.inspection.feature.presentation.auth.login.LoginViewModel
import com.wintermar.inspection.feature.presentation.inspection.answer.InspectionAnswerViewModel
import com.wintermar.inspection.feature.presentation.inspection.answer.search.InspectionSearchQuestionViewModel
import com.wintermar.inspection.feature.presentation.inspection.complete.InspectionCompleteViewModel
import com.wintermar.inspection.feature.presentation.inspection.complete_answer.CompleteAnswerViewModel
import com.wintermar.inspection.feature.presentation.inspection.landing.InspectionLandingViewModel
import com.wintermar.inspection.feature.presentation.splash.SplashViewModel
import com.wintermar.inspection.feature.presentation.template.landing.TemplateLandingViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val viewModelModule = module {
    viewModelOf(::LoginViewModel)
    viewModelOf(::SplashViewModel)
    viewModelOf(::TemplateLandingViewModel)
    viewModelOf(::InspectionLandingViewModel)
    viewModelOf(::InspectionLandingViewModel)
    viewModelOf(::InspectionAnswerViewModel)
    viewModelOf(::InspectionCompleteViewModel)
    viewModelOf(::InspectionSearchQuestionViewModel)
    viewModelOf(::CompleteAnswerViewModel)
}
